<template>
  <main>
    <div class="chapter">
      <div class="chapter__main">{{ changeLang(chapter) }}</div>
    </div>

    <template v-for="data in dataObj">
      <div
        :key="data.id"
        :class="['container', data.type, data.class ? data.class : '']"
      >
        <Label
          v-if="data.type === 'label'"
          :title="changeLang(data.title)"
          :content="changeLang(data)"
          :doc="data.doc"
        />

        <Info
          v-else-if="data.type === 'info'"
          :num="data.num"
          :title="changeLang(data.title)"
          :content="changeLang(data)"
        />

        <Quote
          v-else-if="data.type === 'quote'"
          :num="data.num"
          :content="changeLang(data)"
          :from="data.from"
        />

        <Clipboard
          v-else-if="data.type === 'clipboard'"
          :num="data.num"
          :imgs="data.img"
          :from="data.from"
          :nth="data.nthSlider"
        />

        <LargeText
          v-else-if="data.type === 'large-text'"
          :content="changeLang(data)"
        />

        <Picture v-else-if="data.type === 'picture'" :src="data.src" />

        <Carousel
          v-else-if="data.type === 'carousel'"
          :imgs="data.img"
          :caption="changeLang(data.caption)"
          :nth="data.nthSlider"
        />

        <Sound
          v-else-if="data.type === 'sound'"
          :num="data.num"
          :content="changeLang(data)"
          :doc="data.doc"
          :sources="data.src"
        />

        <Imprint v-if="data.type === 'imprint'" :section="data.section" />
      </div>
    </template>

    <Pano v-if="pano" :source="pano" />
  </main>
</template>

<style scoped>
.chapter__main {
  text-transform: uppercase;
}

.quote {
  margin: 20px;
  width: calc(25% - 40px);
}

.label,
.info,
.clipboard,
.carousel {
  margin: 20px;
  width: calc(50% - 40px);
}

.loading,
.chapter,
.large-text,
.picture,
.imprint,
.flags,
.pano {
  margin: 20px;
  width: calc(100% - 40px);
}

.w-100 {
  margin-right: 50%;
}

@media screen and (max-width: 960px) {
  .label,
  .info,
  .quote,
  .clipboard,
  .carousel,
  .picture,
  .pano {
    width: calc(100% - 40px);
  }

  .w-100 {
    margin-right: 20px;
  }
}

@media screen and (max-width: 600px) {
  body {
    font-size: 12px;
  }
}
</style>

<script>
import Label from "../components/Label.vue";
import Info from "../components/Info.vue";
import Quote from "../components/Quote.vue";
import Clipboard from "../components/Clipboard.vue";
import LargeText from "../components/LargeText.vue";
import Picture from "../components/Picture.vue";
import Carousel from "../components/Carousel.vue";
import Sound from "../components/Sound.vue";
import Imprint from "../components/Imprint.vue";

import Pano from "../components/Panorama.vue";

export default {
  title: "Builder",
  components: {
    Label,
    Info,
    Quote,
    Clipboard,
    LargeText,
    Picture,
    Carousel,
    Sound,
    Imprint,
    Pano
  },
  props: {
    chapter: Object,
    dataObj: Array,
    pano: Array,
    source: String
  },
  methods: {
    changeLang(data) {
      return this.$route.query.lang === "en" ? data.en : data.hu;
    }
  }
};
</script>
